import storage from '@deezer/next/shared/utils/storage';
import type {
	ConfigKeys,
	Config,
	BooleanConfigKeys,
	ToolsStorage,
} from './types';
import {CONFIG_OPTIONS} from './ToolOptions';

const getD4CToolsKey = (key: ConfigKeys) => {
	return `d4c_tools_${key.toLocaleLowerCase()}`;
};

const initConfig = (): Config => {
	return Object.entries(CONFIG_OPTIONS).reduce((acc, [key, option]) => {
		if (option.defaultValue) {
			acc[key as ConfigKeys] = storage.get(
				getD4CToolsKey(key as ConfigKeys),
				option.defaultValue,
			);
		}

		return acc;
	}, {} as Config);
};

const D4CToolsConfig: Config = initConfig();

const D4CToolsStorage: ToolsStorage = {
	setConfigValue: <T extends ConfigKeys>(
		key: T,
		value: T extends BooleanConfigKeys ? boolean : string,
	) => {
		D4CToolsConfig[key] = String(value);
		storage.set(getD4CToolsKey(key), value);
	},
	getConfigValue: <T extends ConfigKeys>(
		key: T,
	): T extends BooleanConfigKeys ? boolean : string => {
		const config = CONFIG_OPTIONS[key];
		const value = D4CToolsConfig[key];

		if (config.type === 'boolean') {
			return JSON.parse(value);
		}

		return value as any;
	},
	getConfig: (): Config => {
		return Object.entries(D4CToolsConfig).reduce((acc, [key, value]) => {
			if (typeof value === 'undefined' || value === null) {
				return acc;
			}
			return {
				...acc,
				[key]: value,
			};
		}, {} as Config);
	},
};

export default D4CToolsStorage;
